import {CLEAR_WORDGROUPS}  from '../_CONSTANTS';

export const clearWordGroups = () => {
  return {
  type: CLEAR_WORDGROUPS,
  payload: {}
}
}

